import { useState } from 'react';
import './Toggle.css'; // Keep styles separate or inline if preferred
import { toast, Axios } from '../../components';

const Toggle = (props) => {
  const { data } = props;
  const [isOn, setIsOn] = useState(data.isSelected === 1 ? true : false);

  const handleToggle = async () => {
    let selectedCarsIds = [...props.selectedCars];
   // Update data in db using API call or state management
    if(!isOn) {
      if (selectedCarsIds.indexOf(data._id.toString()) === -1) {
        selectedCarsIds.push(data._id.toString());
      }
    }else{
      selectedCarsIds = selectedCarsIds.filter(id => id !== data._id);
    }
    Axios.post(props.api_url, {
      carId: selectedCarsIds,
      driverId: data.driverId,
    })
    .then((response) => {
      if(response.data.status === "success"){
        toast.success(response.data.message);
        setIsOn(!isOn);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }else if(response.data.status === "error"){
      }else{
        toast.error(response.data.message);
        setIsOn(isOn); 
      }
    })
    .catch((error) => {
      toast.error(error.message || "Failed to update car selection.");
      setIsOn(isOn); 
    })
  };

  return (
    <div>
      <label className={`toggle-container ${data.status !== 1 ? 'disabled' : ''}`}>
        <input
          type="checkbox"
          className="toggle-checkbox"
          checked={isOn}
          onChange={handleToggle}
          disabled={data.status !== 1 ? true : false}
        />
        <span className="toggle-slider"></span>
      </label>
    </div>
  );
};

export default Toggle;
